import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { number, bool, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import { getSponsorObj } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";
import { cancelablePromise } from "../../utils/utils";

import "./sponsorDetails.m.css";

const SponsorDetails = ({ sponsorId, lang, showImage = true }) => {
  const [sponsors, setSponsors] = useState();
  const [sponsorsLogo, setSponsorsLogo] = useState([]);

  useEffect(() => {
    const promise = cancelablePromise(getSponsorObj(sponsorId));
    promise.promise
      .then((sponsorObj) => {
        const sponsorPhoto = get(sponsorObj, ["photo", "0", "url"], null);
        setSponsors(sponsorObj);
        setSponsorsLogo(sponsorPhoto);
      })
      .catch(() => {});

    return () => {
      promise.cancel();
    };
  }, [sponsorId]);

  if (!sponsors) return null;
  
  return (
    <div styleName="base">
      {sponsors.url ? (
        <Link aria-label={sponsors.title} href={sponsors.url} target="_blank" rel="noindex nofollow">
          <div styleName="sponsor-details">
            {showImage && (
              <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
            )}
            <div styleName={`${!showImage ? "no-image" : ""}`}>
              <div styleName="sponsor-name">{sponsors.title}</div>
              <div styleName="sponsor-type">{staticTexts(lang).sponsorType}</div>
            </div>
          </div>
        </Link>
      ) : (
        <div styleName="sponsor-details">
          {showImage && (
            <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
          )}
          <div styleName={`${!showImage ? "no-image" : ""}`}>
            <div styleName="sponsor-name">{sponsors.title}</div>
            <div styleName="sponsor-type">{staticTexts(lang).sponsorType}</div>
          </div>
        </div>
      )}
    </div>
  );
};

SponsorDetails.propTypes = {
  sponsorId: number,
  lang: string,
  showImage: bool,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(SponsorDetails);
